// extracted by mini-css-extract-plugin
export default {"container":"SearchPage_container__BeSV9","sort":"SearchPage_sort__IHuyU","featured-items":"SearchPage_featured-items__S0rje","no-result":"SearchPage_no-result__neoWp"};